import React, { useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { v4 as uuidv4 } from "uuid";
import Layout from "components/Layout";
import Hero from "components/quiz/landing/Hero";
import Content from "components/quiz/landing/Content";
import Section from "components/quiz/landing/Section";
import { getByID as getPage } from "lib/models/Page";
import { getBySlug, getAll } from "lib/models/Quiz";
import withGlobalFields from "lib/withGlobalFields";
import { useUser } from "lib/user/context";

const QuizLanding = (props) => {
  const router = useRouter();
  const user = useUser();

  // Redirect if quiz isn't available in user's country
  useEffect(() => {
    if (user && !props.countries[user.country]) router.push("/");
  }, [user]);

  return (
    <Layout {...props.global}>
      <Head>
        <title>{`${props.seo.title || props.name} | ${
          props.global.seo.title
        }`}</title>
        <meta name="description" content={props.seo.description} />
        <meta
          name="robots"
          content={props.status === "draft" ? "noindex" : "all"}
        />
      </Head>

      <Hero
        id={props.id}
        image={props.image}
        introduction={props.introduction}
        name={props.name}
        slug={props.slug}
        buttonText={props.button || "Take the Quiz"}
        adsense={props.adsense}
        user={user}
      />

      <Content content={props.imageText} />

      {props.content.map((content, index) => (
        <Section
          key={uuidv4()}
          {...content}
          background={index % 2 === 0 ? "#fff" : "#f5f5f5"}
        />
      ))}
    </Layout>
  );
};

export const getStaticProps = withGlobalFields(async ({ params }) => {
  // Slugs always lowercased
  if (params.slug !== params.slug.toLowerCase()) {
    return {
      redirect: {
        destination: `/quiz/${params.slug.toLowerCase()}`,
        permanent: true,
      },
    };
  }

  const { fields } = await getPage("quiz-landing");

  const quiz = await getBySlug(params.slug, [
    "introduction",
    "name",
    "slug",
    "image",
    "imageText",
    "seo",
    "content",
    "status",
    "adsense",
    "countries",
  ]);

  if (!quiz) {
    return {
      redirect: {
        destination: "/",
        permanent: false,
      },
    };
  }

  return { props: { ...quiz, ...fields } };
});

export async function getStaticPaths() {
  const quizzes = await getAll(["slug"], null, null, ["live", "draft"]);

  const paths = quizzes.map((quiz) => ({ params: { slug: quiz.slug } }));

  return { paths, fallback: false };
}

export default QuizLanding;
